import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HandCoins } from 'lucide-react';
import { prepaymentAPI } from '../../utils/api';
import { cur } from '../../utils/helpers';

/**
 * v3.9: on a purchase / sale form - "this supplier (customer) has an open advance: settle this document from it".
 * value = { prepayment_id, prepayment_amount }; the document must be on credit (the form switches it).
 */
export default function PrepaymentPicker({ kind, partyId, value, onChange, onNeedCredit }) {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!partyId) { setList([]); return; }
    let alive = true;
    prepaymentAPI.open(kind, partyId).then(r => { if (alive) setList(r.data); }).catch(() => { if (alive) setList([]); });
    return () => { alive = false; };
  }, [kind, partyId]);
  const sel = list.find(p => p.id === value?.prepayment_id);
  useEffect(() => {   // the advance belongs to another party now
    if (value?.prepayment_id && list.length && !sel) onChange({ prepayment_id: '', prepayment_amount: '' });
  }, [list]); // eslint-disable-line
  if (!list.length && !value?.prepayment_id) return null;
  return (
    <div className={`ppk ${value?.prepayment_id ? 'on' : ''}`}>
      <div className="ppk-head"><HandCoins size={16} />
        <b>{kind === 'supplier' ? t('ppk_supplier_has') : t('ppk_customer_has')}</b>
        <span>{list.map(p => `${p.number}: ${cur(p.balance, p.currency_code)}`).join(' · ')}</span>
      </div>
      <div className="form-row" style={{ marginBottom: 0 }}>
        <div className="form-group" style={{ marginBottom: 0 }}><label className="form-label">{t('ppk_settle_from')}</label>
          <select className="select" value={value?.prepayment_id || ''} onChange={e => { onChange({ prepayment_id: e.target.value, prepayment_amount: '' }); if (e.target.value && onNeedCredit) onNeedCredit(); }}>
            <option value="">{t('ppk_dont_use')}</option>
            {list.map(p => <option key={p.id} value={p.id}>{p.number} — {t('pp_balance')}: {cur(p.balance, p.currency_code)}{p.mode === 'contract' ? ` (${t('pp_mode_contract')})` : ''}</option>)}
          </select></div>
        {sel && <div className="form-group" style={{ marginBottom: 0 }}><label className="form-label">{t('ppk_amount')} ({sel.currency_code})</label>
          <input className="input" type="number" min="0" step="any" placeholder={t('ppk_amount_ph')} value={value?.prepayment_amount || ''}
            onChange={e => onChange({ ...value, prepayment_amount: e.target.value })} /></div>}
      </div>
      {sel && <p className="text-xs" style={{ color: 'var(--text-muted)', marginTop: 6 }}>{t('ppk_hint')}</p>}
    </div>
  );
}
